export default "__VITE_ASSET__4d22e401__"